import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useCreditErrorHandler } from './use-credit-error-handler';

export const useEdgeFunctionWithCreditHandling = () => {
  const { handleCreditError, isInsufficientCreditsError } = useCreditErrorHandler();

  const invokeEdgeFunction = useCallback(async <T = any>(
    functionName: string,
    body: any,
    options?: any
  ): Promise<T> => {
    try {
      const { data, error } = await supabase.functions.invoke(functionName, { body, ...options });

      if (error) {
        // Check if this is a credit error
        if (error.status === 402 && isInsufficientCreditsError(error)) {
          handleCreditError(error);
        }
        
        // Re-throw the error for normal error handling
        throw error;
      }

      return data;
    } catch (error: any) {
      // Handle cases where error might be in a different format
      if (error?.status === 402 && isInsufficientCreditsError(error)) {
        handleCreditError(error);
      }
      
      throw error;
    }
  }, [handleCreditError, isInsufficientCreditsError]);

  return { invokeEdgeFunction };
}; 